module.exports = __webpack_public_path__ + "img/MV.9504aebb.png";